import { Link } from "react-router-dom";
import { MapPin, ArrowUpRight, ImageOff } from "lucide-react";
import { fotoUrl } from "@/lib/publicApi";
import { brl } from "@/lib/api";

// Card público de pousada para catálogos.
// Props: pousada = objeto do /api/public/pousadas (ou enriquecido)
//        precoDesde = número opcional (menor diária entre quartos ativos)
export function PousadaCard({ pousada, precoDesde = null, testid }) {
  if (!pousada) return null;
  const slug = pousada.slug || pousada.id;
  const foto = pousada.foto_principal_id ? fotoUrl(pousada.foto_principal_id) : null;
  const endereco = (pousada.endereco || "").split(",").slice(0, 2).join(",").trim();
  const descCurta = pousada.descricao_curta || "";

  return (
    <Link
      to={`/pousadas/${slug}`}
      data-testid={testid || `pousada-card-${pousada.id}`}
      className="group relative flex flex-col bg-[#FFFFFF] border border-stone-200 rounded-lg overflow-hidden transition-all hover:border-[#083A6B]/40 hover:shadow-[0_8px_24px_-12px_rgba(44,76,59,0.25)]"
    >
      <div className="relative aspect-[4/3] w-full bg-stone-100 overflow-hidden">
        {foto ? (
          <img
            src={foto}
            alt={pousada.nome}
            loading="lazy"
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-stone-300">
            <ImageOff size={32} strokeWidth={1.3} />
          </div>
        )}
        {pousada.is_chacara && (
          <span className="absolute top-3 left-3 text-[10px] uppercase tracking-[0.2em] bg-[#D4A652] text-white px-2.5 py-1 rounded-full">
            Chácara
          </span>
        )}
      </div>

      <div className="flex-1 flex flex-col p-5 gap-3">
        <div>
          <h3 className="font-public-title text-xl text-stone-900 leading-tight line-clamp-2">
            {pousada.nome}
          </h3>
          {endereco && (
            <div className="flex items-start gap-1.5 text-xs text-stone-500 mt-2">
              <MapPin size={12} className="mt-0.5 flex-shrink-0" />
              <span className="line-clamp-1">{endereco}</span>
            </div>
          )}
        </div>

        {descCurta && (
          <p className="text-sm text-stone-600 leading-relaxed line-clamp-2">
            {descCurta}
          </p>
        )}

        <div className="mt-auto pt-3 flex items-end justify-between border-t border-stone-200/70">
          <div>
            {precoDesde != null && precoDesde > 0 ? (
              <>
                <div className="text-[10px] uppercase tracking-[0.2em] text-stone-500">
                  Diárias a partir de
                </div>
                <div className="font-public-title text-xl text-[#083A6B]">{brl(precoDesde)}</div>
              </>
            ) : (
              <div className="text-xs text-stone-500">Consulte valores</div>
            )}
          </div>
          <span className="inline-flex items-center gap-1 text-[12px] font-medium text-[#083A6B] group-hover:gap-2 transition-all">
            Ver pousada <ArrowUpRight size={14} />
          </span>
        </div>
      </div>
    </Link>
  );
}
